export default "__VITE_ASSET__9Sd3cF2o__"